
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gMqUl3N1x2kTj3HMZQm0bzZKJXdqv2U0Xo6uzmXMP0vAMeta } from "/codebuild/output/src3904904754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexUWIHtDmmutWSdj7zD_QBzOCYYpAac_452Oz9ahEYCXM30Meta } from "/codebuild/output/src3904904754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as search6T1c2Cb2R14X2AxN4d7JWJkvfvWS9TZkr_45Z5aWNWl8EMeta } from "/codebuild/output/src3904904754/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexRVdxHscKppVUMtZf8BBRxWzx_45TPTL8WDo9ix5NGABtEMeta } from "/codebuild/output/src3904904754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93OUAW5KWmOipPXxVXCjjcsYxYH2s3_znQGhFeD666tP8Meta } from "/codebuild/output/src3904904754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexHFu2Ravb8bAa4W5HSTkgsHzoF9TeWIdDEbUDya1r_U4Meta } from "/codebuild/output/src3904904754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93qqqvUPxVoCF04s_45Eho9ZJ8OcXwesHqeIDTwgrg1iY_45YMeta } from "/codebuild/output/src3904904754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexH9clrk1WlPB8syR23ePuwyMs3bmxa8aWiKUoaHtpaI8Meta } from "/codebuild/output/src3904904754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93ei8V5wE6HQXQoCyIQd3w6KqCbGhCaWAVoKqTUGI31ZsMeta } from "/codebuild/output/src3904904754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index_45roeFH7Os9xUHASu1JpG2P6BLl59pQcFwRpzxizWgyYMeta } from "/codebuild/output/src3904904754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexf1VAXGkeJSmrsZid3Zf54iV6tHonluZe228_4DCP_45y4Meta } from "/codebuild/output/src3904904754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3904904754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3904904754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3904904754/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3904904754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3904904754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexHFu2Ravb8bAa4W5HSTkgsHzoF9TeWIdDEbUDya1r_U4Meta || {},
    component: () => import("/codebuild/output/src3904904754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3904904754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexH9clrk1WlPB8syR23ePuwyMs3bmxa8aWiKUoaHtpaI8Meta || {},
    component: () => import("/codebuild/output/src3904904754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3904904754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index_45roeFH7Os9xUHASu1JpG2P6BLl59pQcFwRpzxizWgyYMeta || {},
    component: () => import("/codebuild/output/src3904904754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexf1VAXGkeJSmrsZid3Zf54iV6tHonluZe228_4DCP_45y4Meta || {},
    component: () => import("/codebuild/output/src3904904754/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]